import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSave = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_5754_8432)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M13.4246 16C13.178 15.9993 12.934 15.9498 12.7066 15.8542C12.4792 15.7587 12.2731 15.619 12.1 15.4433L7.99998 11.3673L3.89998 15.446C3.63667 15.7132 3.29897 15.8948 2.93093 15.9672C2.56288 16.0396 2.18155 15.9995 1.83665 15.852C1.48832 15.7119 1.19034 15.47 0.981619 15.1579C0.772894 14.8459 0.663125 14.4781 0.666647 14.1027V3.33333C0.666647 2.44928 1.01784 1.60143 1.64296 0.976311C2.26808 0.351189 3.11593 0 3.99998 0L12 0C12.4377 0 12.8712 0.0862192 13.2756 0.253735C13.68 0.421251 14.0475 0.666782 14.357 0.976311C14.6665 1.28584 14.9121 1.6533 15.0796 2.05772C15.2471 2.46214 15.3333 2.89559 15.3333 3.33333V14.1027C15.337 14.4778 15.2277 14.8453 15.0194 15.1574C14.8112 15.4694 14.5138 15.7115 14.166 15.852C13.9312 15.9502 13.6791 16.0005 13.4246 16ZM3.99998 1.33333C3.46955 1.33333 2.96084 1.54405 2.58577 1.91912C2.21069 2.29419 1.99998 2.8029 1.99998 3.33333V14.1027C1.99974 14.2138 2.03243 14.3224 2.09391 14.4149C2.1554 14.5075 2.24293 14.5797 2.34544 14.6225C2.44795 14.6653 2.56085 14.6768 2.66987 14.6554C2.7789 14.6341 2.87915 14.5809 2.95798 14.5027L7.53331 9.95533C7.65822 9.83117 7.82719 9.76147 8.00331 9.76147C8.17944 9.76147 8.34841 9.83117 8.47331 9.95533L13.0433 14.5013C13.1221 14.5796 13.2224 14.6328 13.3314 14.6541C13.4404 14.6754 13.5533 14.664 13.6559 14.6212C13.7584 14.5784 13.8459 14.5061 13.9074 14.4136C13.9689 14.3211 14.0016 14.2124 14.0013 14.1013V3.33333C14.0013 2.8029 13.7906 2.29419 13.4155 1.91912C13.0405 1.54405 12.5317 1.33333 12.0013 1.33333H3.99998Z",
			fill: "#333333"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5754_8432",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgSave;
